export default __webpack_public_path__ + "static/media/offers.44ae10b4.svg";